"use client";

import * as React from "react";
import { MapPin, ZoomIn, ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel";
import { Button, buttonVariants } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const projects = [{
  title: "STAMPED CONCRETE PATIO",
  location: "NOBLESVILLE, IN",
  category: "Residential",
  description: "A CUSTOM STAMPED CONCRETE PATIO FEATURING A SLATE TEXTURE PATTERN AND CHARCOAL RELEASE AGENT FOR DEPTH. THIS OUTDOOR LIVING SPACE WAS DESIGNED TO WITHSTAND INDIANA WINTERS WHILE PROVIDING AN ELEGANT ENTERTAINMENT AREA.",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/6-2.jpg?v=mwcziy1jhv"
}, {
  title: "Stamped Concrete Patio",
  location: "NOBLESVILLE, IN",
  category: "Commercial",
  description: "A PREMIUM STAMPED CONCRETE INSTALLATION FEATURING A HERRINGBONE BRICK PATTERN WITH A MULTI-TONE ANTIQUE FINISH. THIS DURABLE SURFACE COMBINES THE TIMELESS LOOK OF MASONRY WITH THE UNMATCHED STRENGTH OF REINFORCED CONCRETE.",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/3-2.jpg?v=oc5glrqivsj"
}, {
  title: "Stairs & Sidewalk Installation",
  location: "FISHERS, IN",
  category: "Residential",
  description: "EXPERTLY CRAFTED CONCRETE STAIRS AND SIDEWALKS FEATURING A NON-SLIP BROOM FINISH. ENGINEERED FOR STABILITY AND DURABILITY TO ENSURE SAFE ACCESS AND ENHANCED CURB APPEAL FOR YEARS TO COME.",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/9-2.jpg?v=lhzdgvwlgw"
}, {
  title: "Stairs & Sidewalk Installation",
  location: "Fishers, IN",
  category: "Residential",
  description: "HIGH-QUALITY CONCRETE STAIRS AND SIDEWALK CONSTRUCTION FEATURING A PRECISION BROOM FINISH FOR ADDED TRACTION. THIS INSTALLATION PROVIDES A CLEAN, PROFESSIONAL LOOK WHILE ENSURING SAFE AND RELIABLE ACCESS TO THE PROPERTY.",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/8-1.jpg?v=qm7z1umb9x8"
}, {
  title: "Basement Installation",
  location: "Carmel, IN",
  category: "Landscape",
  description: "Basement Installation: Step One - Breaking ground and digging for the foundation of the basement",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/5.jpg?v=j1lpkoaj1ui"
}, {
  title: "Basement Installation",
  location: "Carmel, IN",
  category: "Residential",
  description: "Basement Installation: Step Two - Setting the forms and installing the vapor barrier and reinforcement.",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/20250517_122753792_iOS_2-1-scaled.jpeg?v=ny0zxie2cbo"
}, {
  title: "Basement Installation",
  location: "Carmel, IN",
  category: "Commercial",
  description: "High‑strength concrete mix delivery with precise slump control and placement.",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/20250517_173240169_iOS_1-scaled.jpeg?v=07ilvutqaqc4"
}, {
  title: "Basement Installation",
  location: "CARMEL, IN",
  category: "Residential",
  description: "COOL-TOUCH CONCRETE POOL DECK WITH A SAND-BLASTED FINISH FOR SAFETY AND COMFORT. THE CLEAN LINES AND LIGHT COLOR PALETTE REFLECT HEAT, MAKING IT THE PERFECT SUMMER RETREAT.",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/6.jpg?v=iuuxv9528bg"
}, {
  title: "Concrete Patio Installation",
  location: "Kokomo, IN",
  category: "Residential",
  description: "Step 1: Clear and level the site. Step 2: Install forms and a compacted base. Step 3: Pour and finish the concrete for a residential patio.",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/2-3.jpg?v=w63ktyv4iy"
}, {
  title: "Concrete Patio Installation",
  location: "KOKOMO, IN",
  category: "Commercial",
  description: "PRECISION-POURED Concrete Patio Installation. ENGINEERED WITH HIGH-STRENGTH CONCRETE MIX AND LASER-LEVELED FOR EXACT SPECIFICATIONS.",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/1-3.jpg?v=29f244fcnb2"
}, {
  title: "Driveway Installation",
  location: "ZIONSVILLE, IN",
  category: "Residential",
  description: "PREMIUM RESIDENTIAL DRIVEWAY INSTALLATION FEATURING A SLIP-RESISTANT BROOM FINISH AND REINFORCED EDGES. DESIGNED FOR SUPERIOR DURABILITY AND ENHANCED CURB APPEAL TO WITHSTAND HEAVY TRAFFIC AND MIDWEST CLIMATES.",
  image: "https://dscconcreteconstruction.com/wp-content/uploads/2026/03/7-3.jpg?v=ylqzy9jgjm"
}, {
  title: "Commercial Foundation Pour",
  location: "INDIANAPOLIS, IN",
  category: "Commercial",
  description: "LARGE-SCALE COMMERCIAL FOUNDATION POUR FOR A NEW INDUSTRIAL WAREHOUSE. ENGINEERED FOR MAXIMUM LOAD-BEARING CAPACITY WITH REINFORCED REBAR GRID AND PRECISION FINISHING.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568171/img/commercial_foundation_indianapolis.png"
}, {
  title: "Decorative Pool Deck",
  location: "GEIST, IN",
  category: "Residential",
  description: "STUNNING DECORATIVE CONCRETE POOL DECK FEATURING A NON-SLIP TEXTURE AND CUSTOM COLOR BORDER. DESIGNED TO COMPLEMENT THE LUXURY OUTDOOR LIVING SPACE WHILE PROVIDING SAFETY AND DURABILITY.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568171/img/decorative_pool_deck_geist.png"
}, {
  title: "Exposed Aggregate Walkway",
  location: "WESTFIELD, IN",
  category: "Residential",
  description: "BEAUTIFUL EXPOSED AGGREGATE WALKWAY PROVIDING A NATURAL STONE AESTHETIC WITH THE STRENGTH OF CONCRETE. PERFECT FOR ADDING TEXTURE AND CHARACTER TO RESIDENTIAL LANDSCAPING.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568171/img/exposed_aggregate_walkway_westfield.png"
}, {
  title: "Polished Concrete Garage Floor",
  location: "AVON, IN",
  category: "Residential",
  description: "HIGH-GLOSS POLISHED CONCRETE GARAGE FLOOR. TRANSFORMING A STANDARD UTILITY SPACE INTO A CLEAN, REFLECTIVE, AND EASY-TO-MAINTAIN SHOWROOM-QUALITY SURFACE.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1568171/img/polished_concrete_garage_avon.png"
}];
export default function RecentWorkGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="recent-work-gallery" ref={ref} className="bg-background py-20 md:py-28">
      <div className="container mx-auto px-4">
        <div className={cn("mx-auto mb-16 max-w-3xl text-center transition-all duration-700", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          <h2 className="font-serif text-foreground mb-4 text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
            BUILT TO LAST. DESIGNED TO IMPRESS.
          </h2>
          <p className="text-muted-foreground text-lg !h-[115px] md:text-xl">
            BROWSE OUR GALLERY OF RECENT RESIDENTIAL AND COMMERCIAL PROJECTS
            ACROSS CENTRAL AND NORTHERN INDIANA. FROM DECORATIVE PATIOS TO
            INDUSTRIAL FOUNDATIONS, WE DELIVER PRECISION IN EVERY POUR.
          </p>
        </div>

        <Carousel opts={{
        align: "start"
      }} className="w-full px-12">
          <CarouselContent>
            {projects.map((project, i) => <CarouselItem key={i} data-index={i} className="md:basis-1/2 lg:basis-1/4">
                <Dialog>
                  <DialogTrigger asChild>
                    <div className={cn("group relative cursor-pointer overflow-hidden rounded-sm bg-muted shadow-sm transition-all duration-700", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")} style={{
                  transitionDelay: `${i * 100}ms`
                }}>
                      <AspectRatio ratio={1}>
                        <img src={project.image} alt={project.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110 contrast-125 filter" />
                        
                        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/70 p-6 text-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                          <h3 className="text-white mb-2 translate-y-4 text-xl font-bold transition-transform duration-300 group-hover:translate-y-0">
                            {project.title}
                          </h3>
                          <p className="text-white/80 mb-6 translate-y-4 text-sm transition-transform duration-300 delay-75 group-hover:translate-y-0">
                            {project.location}
                          </p>
                          <div className="translate-y-4 transition-transform duration-300 delay-100 group-hover:translate-y-0">
                            <Link to="tel:317-709-9540" className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-10 rounded-md px-6 has-[>svg]:px-4 gap-2 !text-[hsl(25,95%,53%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50">
                              call to schedule a quote
                            </Link>
                          </div>
                        </div>
                      </AspectRatio>
                    </div>
                  </DialogTrigger>
                  <DialogContent className="max-w-4xl gap-0 overflow-hidden p-0 sm:max-w-5xl">
                    <div className="grid md:grid-cols-2">
                      <div className="relative h-64 bg-muted md:h-auto">
                        <img src={project.image} alt={project.title} className="absolute inset-0 h-full w-full object-cover" />
                      </div>
                      <div className="flex flex-col justify-center p-8 md:p-10">
                        <DialogHeader className="mb-6 text-left">
                          <div className="text-primary mb-2 flex items-center gap-2 text-sm font-semibold uppercase tracking-wider">
                            <MapPin className="h-4 w-4" />
                            {project.location}
                          </div>
                          <DialogTitle className="font-serif text-3xl font-bold leading-tight">
                            {i === 7 ? "Basement Installation - Step Four of a 4-Step Process" : project.title}
                          </DialogTitle>
                          <DialogDescription className="text-muted-foreground mt-4 text-base leading-relaxed">
                            {i === 9 ? "part 2 and finishing of the concrete patio installation for the finished product" : project.description}
                          </DialogDescription>
                        </DialogHeader>

                        <div className="mt-auto space-y-6 border-t pt-6">
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <span className="text-muted-foreground block text-xs uppercase tracking-wider">
                                Category
                              </span>
                              <span className="font-medium">
                                {project.category}
                              </span>
                            </div>
                            <div>
                              <span className="text-muted-foreground block text-xs uppercase tracking-wider">
                                Material
                              </span>
                              <span className="font-medium">Concrete</span>
                            </div>
                          </div>
                          <Link to="tel:317-709-9540" className={cn(buttonVariants({
                        size: "lg"
                      }), "w-full")}>
                            call to schedule a quote
                          </Link>
                        </div>
                      </div>
                    </div>
                  </DialogContent>
                </Dialog>
              </CarouselItem>)}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>

        <div className="mt-12 text-center">
          <Link to="tel:317-709-9540" className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-10 rounded-md px-6 has-[>svg]:px-4 gap-2 !bg-[hsl(25,95%,53%)] !text-[hsl(0,0%,100%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50">
            call to schedule a quote
          </Link>
        </div>
      </div>
    </section>;
}